import styled from "styled-components";

const ConcreteViewStyled = styled.div``;

export { ConcreteViewStyled };
